import { createVNode, mergeProps } from "vue";
export default {
  name: 'Trash2Icon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-trash-2"
    }, { ...attrs
    }), [createVNode("polyline", {
      "points": "3 6 5 6 21 6"
    }), createVNode("path", {
      "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
    }), createVNode("line", {
      "x1": "10",
      "y1": "11",
      "x2": "10",
      "y2": "17"
    }), createVNode("line", {
      "x1": "14",
      "y1": "11",
      "x2": "14",
      "y2": "17"
    })]);
  }

};